import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['containerNumbers', 'numberKeys'];

  connect() {
    this.initializeIntersectionObserver();
  }

  initializeIntersectionObserver = () => {
    const options = {
      root: null,
      rootMargin: '200px',
      threshold: 0.5
    };

    const observer = new IntersectionObserver(this.handleObserver, options);
    if (this.containerNumbersTarget) {
      observer.observe(this.containerNumbersTarget);
    }
  };

  handleObserver = (entities) => {
    const target = entities[0];
    if (target.isIntersecting) {
      this.animateNumber();
    }
  };

  animateNumber = () => {
    const duration = 1000;
    this.numberKeysTargets.forEach((block) => {
      const finalValue = +block.getAttribute('number');
      const startTime = performance.now();
      
      const animate = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        
        const currentValue = Math.floor(progress * finalValue);
        block.innerText = currentValue;
        
        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          block.innerText = finalValue;
        }
      };
      
      requestAnimationFrame(animate);
    });
  };
}
